import React from 'react';
import { Platform } from 'react-native';
import {View, Text, Button, Center} from 'native-base';
import LoadingSpinner from './LoadingSpinner';

interface I_ConfirmationDialog_Props {
  isOpen: boolean;
  onClose: () => void;
  onYesPressed: () => void;
  onNoPressed: () => void;
  description: string;
  title?: string;
  loading?: boolean;
  negativeLabel?: string;
  positiveLabel?: string;
  centerButton?: boolean;
  centerButtonLabel?: string;
  onCenterButtonPressed?: () => void;
}

const ConfirmationDialog = ({
  isOpen,
  onClose,
  onYesPressed,
  onNoPressed,
  description,
  title,
  loading,
  negativeLabel = `NO `,
  positiveLabel = 'YES',
  centerButton,
  centerButtonLabel,
  onCenterButtonPressed,
}: I_ConfirmationDialog_Props) => {
  const cancelRef = React.useRef(null);

  return (
    isOpen && (
      <View
        style={{
      position: Platform.OS === 'web' ? 'fixed' : 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: Platform.OS === 'web' ? '100vw' : '100%',
      height: Platform.OS === 'web' ? '100vh' : '100%',
      backgroundColor: 'rgba(0,0,0,0.5)',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
        }}
      >
        <View
      style={{
        backgroundColor: 'white',
        borderRadius: 8,
        padding: 24,
        minWidth: 280,
        maxWidth: '90%',
        alignItems: 'center',
      }}
        >
      <View style={{ marginBottom: 12 }}>
        <Text style={{ fontWeight: 'bold', fontSize: 18 }}>
          {!!title ? title : 'Confirm'}
        </Text>
      </View>
      <View style={{ marginBottom: 24 }}>
        <Text style={{ fontSize: 16, textAlign: 'center' }}>
          {description}
        </Text>
      </View>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <Button
          variant="ghost"
          onPress={() => {
        onClose();
        onNoPressed();
          }}
          isDisabled={!!loading}
        >
          {negativeLabel}
        </Button>
        {centerButton && (
          <Button
        variant="ghost"
        onPress={() => {
          onClose();
          !!onCenterButtonPressed && onCenterButtonPressed();
        }}
          >
        {centerButtonLabel}
          </Button>
        )}
        {!!loading ? (
          <LoadingSpinner size="small" />
        ) : (
          <Button
        colorScheme="red"
        onPress={() => {
          onClose();
          onYesPressed();
        }}
          >
        {positiveLabel}
          </Button>
        )}
      </View>
        </View>
      </View>
    )
  );
};

export default ConfirmationDialog;
